import { useAuth0 } from "@auth0/auth0-react";

import API_Call_Handler from "@/api/API_Call_Handler";
import API_Calls_Utils from "@/api/API_Calls_Utils";
import { getBackendUrl } from "@/utils/util";

export default function API_Calls_ManagementToken() {
  const backendUrl = getBackendUrl();
  const { getAccessTokenSilently } = useAuth0();
  const { apiCall } = API_Call_Handler();
  const { getManagementTokenHeaders } = API_Calls_Utils();

  async function getManagementToken() {
    try {
      const tkn = await getAccessTokenSilently();
      const { headers } = await getManagementTokenHeaders({});

      const response = await apiCall({
        url: `${backendUrl}/api/users/token/mgmt_api_token`,
        method: "POST",
        headers,
      });
      return [tkn, response.headers["x-access-token"]];
    } catch {
      return [];
    }
  }

  return {
    getManagementToken,
  };
}
